import { faMapMarkerAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import CONSTANTS from '../../constants';
import GoogleHelper from '../../helpers/GoogleHelper';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';
import LocationService from '../../services/LocationService';
import UserLocationService from '../../services/UserLocationService';
import SharedMap from '../shared/SharedMap';

class MapModal extends Component {

  constructor(props) {
    super(props);
    this.timeout = 0;
    this.state = {
      showMap: false,
      location: null,
      selectedOutlet: this.props.selectedOutlet || null,
      currentLocation: null,
      address: '',
      note: '',
      location_name: '',
      isSync: false,
      itemIndex: '',
      isLocationSet: false,
      isLocName: false,
      predictions: [],
      isFirst: true,
      isDrag: false,
      isDragError: false,
      loading: false
    };
  }

  componentDidMount() {
    // let flag = UserLocationService.getCheckForLocation();
    // if (flag === 'false') {
    // 	return navigator.geolocation.getCurrentPosition(
    // 		this.onGeoLocationSuccess.bind(this),
    // 		this.onGeoLocationError.bind(this),
    // 		{
    // 			enableHighAccuracy: true,
    // 			timeout: CONSTANTS.SETTINGS.LOCATION_TIMEOUT
    // 		}
    // 	);
    // }
  }

  async componentDidUpdate(prevProps) {
    if (!this.props.showModal && prevProps.showModal) {
      await this.setState(
        {
          address: '',
          note: '',
          location_name: '',
          itemIndex: '',
          location: null
        },
        () => {
          let flag = UserLocationService.getCheckForLocation();
          if (flag === 'false') {
            return navigator.geolocation.getCurrentPosition(
              this.onGeoLocationSuccess.bind(this),
              this.onGeoLocationError.bind(this),
              {
                enableHighAccuracy: true,
                timeout: CONSTANTS.SETTINGS.LOCATION_TIMEOUT
              }
            );
          }
        }
      );
    }

    if (
      this.props !== prevProps
    ) {
      await this.setState({
        location: {
          lat: this.props.editLocation ? this.props.editLocation.latitude : this.props.selectedOutlet.latitude,
          lng: this.props.editLocation ? this.props.editLocation.longitude : this.props.selectedOutlet.longitude,
          address: this.props.editLocation ? this.props.editLocation.address : ''
        },
        address: this.props.editLocation ? this.props.editLocation.address : '',
        itemIndex: this.props.itemIndex,
        note: this.props.editLocation ? this.props.editLocation.note : '',
        location_name: this.props.editLocation ? this.props.editLocation.name : ''
      });
    }

    if (this.props.selectedOutlet?.loc_id !== prevProps.selectedOutlet?.loc_id) {
      this.setState({ selectedOutlet: this.props.selectedOutlet });
    }
  }

  onGeoLocationSuccess(position) {
    let { latitude, longitude } = position.coords;
    let location = { lat: latitude, lng: longitude, address: '' };
    if (this.state.location) return this.setState({ currentLocation: location });
    this.setState({ currentLocation: location, location });
  }

  onGeoLocationError(error) {
    UserLocationService.setCheckForLocation(true);
    ViewHelper.showAlert({
      title: 'Location Permission',
      text: 'Plugd needs your device location for delivery orders. Please enable your GPS.',
      icon: 'warning',
    });
  }

  async displaySuggestions(predictions, status) {
    if (status === 'UNKNOWN_ERROR') {
      ViewHelper.showAlert({
        title: 'Map Alert',
        text: 'Something went wrong. please try again!',
        icon: 'warning',
      });
      return;
    }

    if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
      await this.setState({ loading: false });
      return;
    }
    let location = await GoogleHelper.getLatLongFromAddress(predictions[0].description);
    await this.setState({ location, loading: false });
  }

  async geoCodeAddress() {
    if (this.state.address) {
      const service = new window.google.maps.places.AutocompleteService();
      let geolocation = new window.google.maps.LatLng(
        this.props.selectedOutlet?.latitude,
        this.props.selectedOutlet?.longitude
      )
      let circle = new window.google.maps.Circle({ center: geolocation, radius: 30000 });
      service.getPlacePredictions(
        {
          input: this.state.address,
          locationRestriction: circle.getBounds(),
          componentRestrictions: { country: 'pk' }
        },
        await this.displaySuggestions.bind(this)
      );
    }
  }

  toggleMap() {
    this.setState({ showMap: !this.state.showMap });
  }

  async onLocationSelect(t, map, coord) {
    await this.setState({
      location: {
        lat: coord.latLng.lat(),
        lng: coord.latLng.lng(),
        address: ''
      },
      isFirst: false,
      isDrag: true,
      isDragError: false
    });
  }

  onPlaceSelect(location, addr) {
    this.setState(
      {
        location: {
          lat: location.lat,
          lng: location.lng,
          address: addr
        }
      },
      () => {
        if (this.state.selectedOutlet) {
          const distance = GoogleHelper.distanceBetweenTwoLatLngStrings(
            `${this.state.location.lat},${this.state.location.lng}`,
            `${this.state.selectedOutlet.latitude},${this.state.selectedOutlet.longitude}`
          );
          if (distance > 500) {
            this.props.onChangeOutlet(null, false);
          }
        }
      }
    );
    this.setState({ isLocationSet: false });
  }

  async onMapChange(t, map) {
    await this.setState({
      location: {
        lat: map.center.lat(),
        lng: map.center.lng(),
        address: ''
      },
      isFirst: false,
      isDrag: true,
      isDragError: false
    });
  }

  goToCurrentLocation() {
    navigator.geolocation.getCurrentPosition(
      this.onGeoLocationSuccess.bind(this),
      this.onGeoLocationError.bind(this),
      {
        enableHighAccuracy: true,
        timeout: CONSTANTS.SETTINGS.LOCATION_TIMEOUT
      }
    );
    this.setState({ location: this.state.currentLocation });
  }

  sendLocation() {
    this.toggleMap();
    if (this.state.location) this.invokeCallBack(this.state.location);
  }

  invokeCallBack(location) {
    let locationString = location ? `${location.lat},${location.lng}` : '';
    this.props.onChange({
      target: {
        suppressErrors: true,
        name: 'delivery_location',
        value: locationString
      }
    });
  }

  firebaseEvent(eventName, data = {}) {
    AnalyticsService.logEvent(eventName, {
      category: CONSTANTS.EVENTS.CONFIRM_ORDER.GROUP_NAME,
      ...data
    });
  }

  locationLabel() {
    if (!this.props.delivery_location) return 'Specify your location on map';
    if (JSON.stringify(this.state.currentLocation) === JSON.stringify(this.state.location))
      return 'Current Location';
    return 'Custom Location';
  }

  onOutletSelect(outlet) {
    this.setState({ selectedOutlet: outlet });
    this.props.onChangeOutlet(outlet, false);
  }

  onDone() {
    this.props.toggleModal();
    this.props.onChangeOutlet(this.state.selectedOutlet);
  }

  async onInputchange(event) {
    const name = event.target.name;
    if (this.timeout) clearTimeout(this.timeout);
    if (event.target.value === '') {
      await this.setState({
        [name]: event.target.value,
        loading: false,
        isDragError: false
      });
    } else {
      if (name === 'address') {
        this.setState(
          {
            [name]: event.target.value,
            loading: true
          },
          async () => {
            this.timeout = setTimeout(() => {
              if (this.state.address.length < 3)
                return;
              if (name === 'address') {
                this.geoCodeAddress()
              }
            }, 1500);
          }
        );
      } else {
        this.setState(
          {
            [name]: event.target.value,
          }
        )
      }
    }
    await this.setState({
      isLocationSet: false,
      isLocName: false,
      isDrag: false,
      isDragError: false,
      isFirst: false
    });


  }

  async saveLocation() {
    if (this.state.address === '') {
      const element = document.getElementById('address');
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      await this.setState({ isLocationSet: !this.state.isLocationSet });
      return;
    }
    if (!this.state.isFirst && !this.state.isDragError) {
      if (!this.state.isDrag) {
        await this.setState({ isDragError: true });
        return;
      }
    }
    if (this.state.isDragError) {
      return;
    }
    if (this.state.isSaving) {
      return;
    }
    try {
      await this.setState({ isSaving: true });
      const { location, address, location_name } = this.state;
      if (location === null) {
        await this.setState({ isLocationSet: !this.state.isLocationSet });
      }
      if (address === '') {
        await this.setState({ isLocationSet: !this.state.isLocationSet });
      } else {
        let loc = null;
        if (location_name === '') {
          await this.setState({ location_name: address ? address : 'Location' });
        }
        if (this.props.editLocation) {
          loc = await UserLocationService.updateSavedLocations(this.state);
        } else {
          loc = await UserLocationService.setSavedLocations(this.state);
        }
        this.props.updateSavedLocations(true, loc);
      }
      await this.setState({ isSaving: false, location_name: '' });
    } catch (e) {
      await this.setState({ isSaving: false });
    }
  }

  isDoneEnabled() {
    return this.state.selectedOutlet;
  }
  async toggleClose() {
    this.setState({ isDragError: false })
    this.props.toggleModal();
  }

  render() {
    // const closeBtn = <button className="close" onClick={this.props.toggleModal}>&times;</button>;
    const outletsForBounds = this.state.location
      ? LocationService.viewableLocations(
        this.props.data,
        `${this.state.location.lat},${this.state.location.lng}`,
        5
      )
      : this.props.data;
    const outlets = this.props.data;
    if (this.props.isGPSAlert) {
      this.props.toggleIsGpsAlert();
    }
    const grid_layout = localStorage.getItem('grid_layout');
    const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
    const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : 'card-outline-color-hide';
    if (grid_layout === 'old') {
      return (
        <React.Fragment>
          <Modal
            isOpen={this.props.showModal}
            toggle={this.props.toggleModal}
            className="modal sub-modal-m my-map-modal"
          >
            {/* {closeBtn} */}
            <div className="modal-header no-border primary-color">
              <h5 className="modal-title text-bold primary-font-color">
                {this.props.editLocation ? 'Edit Location' : this.props.name}
              </h5>
              <div className={`primary-color`} onClick={this.props.toggleModal}>
                <FontAwesomeIcon icon={faTimes} color='var(--primary-font-color)' />
              </div>
            </div>
            <ModalBody className="primary-color">
              {!this.props.isTakeAway && (
                <>
                  <div className="card flex-md-row box-shadow h-md-250 p-3 no-border primary-color">
                    <div className="row row-width p-0 m-0">
                      <div className="col-lg-12 order-types " id="order_type_id">
                        <form onSubmit={e => { e.preventDefault(); }}>
                          <div className="form-group py-1">
                            <div className='d-flex'>
                              <input
                                type="text"
                                className="form-control card-color card-font-color"
                                id="inputAddress"
                                placeholder="Full Delivery Address"
                                name="address"
                                value={this.state.address}
                                onChange={this.onInputchange.bind(this)}
                                required
                              />

                              {this.state.loading && (
                                <div className="text-sm spinner-border primary-font-color m-2" role="status" style={{ width: '35px' }}>
                                  <span className="sr-only"></span>
                                </div>
                              )}
                            </div>
                            {this.state.isLocationSet && (
                              <small className="text-danger">Please enter your full address.</small>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div
                className={`map-container ${!this.props.isTakeAway ? 'takeaway-map-container' : ''
                  }`}
              >
                {this.state.isDragError && (
                  <small>
                    <span class="ps-4 text-danger">
                      Please drag the map to your exact location.
                    </span>
                  </small>
                )}
                {/* <div className='places'>
								<Places placeholder='Search' onSelect={this.onPlaceSelect.bind(this)} selectedOutlet={this.props.selectedOutlet} />
							</div> */}
                <div className={`map ${this.state.isDragError ? 'map-shake' : ''}`}>
                  {this.props.showModal && (
                    <SharedMap
                      defaultLocation={this.state.location}
                      currentLocation={this.state.currentLocation}
                      onLocationSelect={this.onLocationSelect.bind(this)}
                      onMapChange={this.onMapChange.bind(this)}
                      goToCurrentLocation={this.goToCurrentLocation.bind(this)}
                      outlets={outlets}
                      outletsForBounds={outletsForBounds}
                      onOutletSelect={this.onOutletSelect.bind(this)}
                      selectedOutlet={this.state.selectedOutlet}
                      isTakeAway={this.props.isTakeAway}
                      redraw={this.props.showModal}
                      isEditLocation={this.props.editLocation}
                    />
                  )}
                </div>
              </div>
              {!this.props.isTakeAway && (
                <>
                  <div className="card flex-md-row box-shadow h-md-250 p-3 no-border primary-color">
                    <div className="row row-width p-0 m-0">
                      <div className="col-lg-12 order-types " id="order_type_id">
                        <form onSubmit={e => { e.preventDefault(); }}>
                          <div className="form-group py-1">
                            <input
                              type="text"
                              className="form-control card-color card-font-color"
                              id="location_name"
                              name="location_name"
                              placeholder="Name (E.g. Home, Work, Mom's house etc)"
                              value={this.state.location_name}
                              onChange={this.onInputchange.bind(this)}
                              required
                            />
                            {this.state.isLocName && (
                              <small className="text-danger">
                                Please enter your location name.
                              </small>
                            )}
                          </div>
                          <div className="form-group py-1">
                            <input
                              type="text"
                              className="form-control card-color card-font-color"
                              id="note"
                              name="note"
                              placeholder="Add note (E.g. don't ring bell, Nearby Landmark etc)"
                              value={this.state.note}
                              onChange={this.onInputchange.bind(this)}
                              required
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.props.isTakeAway && (
                <div className="card flex-md-row box-shadow h-md-250 p-3 card-color m-2">
                  <div className="row row-width m-0 p-0">
                    <div className="col-lg-12 order-types " id="order_type_id">
                      <div className="pl-3 pr-3" id="order_time">
                        <div className="time-field mb-0">
                          <div className="f2">
                            <span className="pl-2 card-font-color">
                              {this.state.selectedOutlet
                                ? this.state.selectedOutlet.name
                                : `${outletsForBounds.length} Outlets`}
                            </span>
                            <br />
                            <small>
                              <span className="pl-2 card-font-color">
                                {this.state.selectedOutlet
                                  ? this.state.selectedOutlet.formattedAddress
                                  : ''}
                              </span>
                            </small>
                          </div>
                          <div className="action">
                            <span className='card-font-color'>
                              {this.state.selectedOutlet && this.state.location
                                ? `${GoogleHelper.distanceBetweenTwoLatLngStrings(
                                  `${this.state.location.lat},${this.state.location.lng}`,
                                  `${this.state.selectedOutlet.latitude},${this.state.selectedOutlet.longitude}`
                                )} KM`
                                : ''}
                              &nbsp;
                              <FontAwesomeIcon icon={faMapMarkerAlt} color='var(--card-font-color)' />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </ModalBody>
            <ModalFooter className="no-border primary-color">
              <div className="container-fluid">
                <div className="row">
                  {this.props.isTakeAway && (
                    <Button
                      className={`col-lg-12 btn btn-primary btn-lg ${branding_btn}`}
                      disabled={!this.isDoneEnabled() || this.state.loading || this.state.isSaving}
                      onClick={this.onDone.bind(this)}
                    >
                      Done
                    </Button>
                  )}
                  {!this.props.isTakeAway && (
                    <Button
                      className={`col-lg-12 btn btn-primary btn-lg ${branding_btn}`}
                      disabled={this.state.isSaving || this.state.loading}
                      onClick={this.saveLocation.bind(this)}
                    >
                      Save Location
                    </Button>
                  )}
                </div>
              </div>
            </ModalFooter>
          </Modal>
        </React.Fragment>
      );
    } else if (grid_layout !== 'old') {
      return (
        <React.Fragment>
          <StyledMapModal
            isOpen={this.props.showModal}
            toggle={this.props.toggleModal}
            className="modal sub-modal-m my-map-modal"
          >
            {/* {closeBtn} */}
            <div className="modal-header no-border primary-color">
              <h5 className="modal-title text-bold primary-font-color">
                {this.props.editLocation ? 'Edit Location' : this.props.name}
              </h5>
              <div onClick={this.toggleClose.bind(this)} className={`icon-close primary-color ${card_outline}`}>
                <FontAwesomeIcon icon={faTimes} color='var(--primary-font-color)' />
              </div>
            </div>
            <ModalBody className='primary-color'>
              {!this.props.isTakeAway && (
                <>
                  <div className="card flex-md-row box-shadow h-md-250 ps-4 pb-4 no-border primary-color">
                    <div className="row row-width">
                      <div className="col-lg-12 order-types " id="order_type_id">
                        <form onSubmit={e => { e.preventDefault(); }}>

                          <div id='address' className="form-group">
                            <h2 className='primary-font-color'>Address</h2>
                            <div className='d-flex'>
                              <input
                                type="text"
                                className="form-control card-color card-font-color"
                                id="inputAddress"
                                placeholder="Full Delivery Address"
                                name="address"
                                value={this.state.address}
                                onChange={this.onInputchange.bind(this)}
                                required
                              />

                              {this.state.loading && (
                                <div className="text-sm spinner-border text-primary m-2" role="status" style={{ width: '35px' }}>
                                  <span className="sr-only"></span>
                                </div>
                              )}
                            </div>
                            {this.state.isLocationSet && (
                              <small className="text-danger">Please enter your full address.</small>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div
                className={`map-container ${!this.props.isTakeAway ? 'takeaway-map-container' : ''
                  }`}
              >
                {this.state.isDragError && (
                  <small>
                    <span class="ps-4 text-danger">
                      Please drag the map to your exact location.
                    </span>
                  </small>
                )}
                {/* <div className='places'>
									<Places placeholder='Search' onSelect={this.onPlaceSelect.bind(this)}
										selectedOutlet={this.props.selectedOutlet} />
								</div> */}
                <div className={`map ${this.state.isDragError ? 'map-shake' : ''}`}>
                  {this.props.showModal && (
                    <SharedMap
                      defaultLocation={this.state.location}
                      currentLocation={this.state.currentLocation}
                      onLocationSelect={this.onLocationSelect.bind(this)}
                      onMapChange={this.onMapChange.bind(this)}
                      goToCurrentLocation={this.goToCurrentLocation.bind(this)}
                      outlets={outlets}
                      outletsForBounds={outletsForBounds}
                      onOutletSelect={this.onOutletSelect.bind(this)}
                      selectedOutlet={this.state.selectedOutlet}
                      isTakeAway={this.props.isTakeAway}
                      redraw={this.props.showModal}
                      isEditLocation={this.props.editLocation}
                    />
                  )}
                </div>
              </div>
              {!this.props.isTakeAway && (
                <>
                  <div className="card flex-md-row box-shadow h-md-250 ps-4 pb-4 mt-2 no-border primary-color">
                    <div className="row row-width">
                      <div className="col-lg-12 order-types " id="order_type_id">
                        <form onSubmit={e => { e.preventDefault(); }}>
                          <div className="form-group">
                            <h2 className='primary-font-color'>Name</h2>
                            <input
                              type="text"
                              className="form-control card-color card-font-color"
                              id="location_name"
                              name="location_name"
                              placeholder="Name (E.g. Home, Work, Mom's house etc)"
                              value={this.state.location_name}
                              onChange={this.onInputchange.bind(this)}
                              required
                            />
                            {this.state.isLocName && (
                              <small className="text-danger">
                                Please enter your location name.
                              </small>
                            )}
                          </div>
                          <div className="form-group">
                            <h2 className='primary-font-color'>Note</h2>
                            <input
                              type="text"
                              className="form-control card-color card-font-color"
                              id="note"
                              name="note"
                              placeholder="Add note (E.g. don't ring bell, Nearby Landmark etc)"
                              value={this.state.note}
                              onChange={this.onInputchange.bind(this)}
                              required
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {this.props.isTakeAway && (
                <div className="card flex-md-row box-shadow h-md-250 p-3 card-color m-2">
                  <div className="row row-width m-0 p-0">
                    <div className="col-lg-12 order-types " id="order_type_id">
                      <div className="pl-3 pr-3" id="order_time">
                        <div className="time-field mb-0">
                          <div className="f2">
                            <span className="pl-2 card-font-color">
                              {this.state.selectedOutlet
                                ? this.state.selectedOutlet.name
                                : `${outletsForBounds.length} Outlets`}
                            </span>
                            <br />
                            <small>
                              <span className="pl-2 card-font-color">
                                {this.state.selectedOutlet
                                  ? this.state.selectedOutlet.formattedAddress
                                  : ''}
                              </span>
                            </small>
                          </div>
                          <div className="action">
                            <span className='card-font-color'>
                              {this.state.selectedOutlet && this.state.location
                                ? `${GoogleHelper.distanceBetweenTwoLatLngStrings(
                                  `${this.state.location.lat},${this.state.location.lng}`,
                                  `${this.state.selectedOutlet.latitude},${this.state.selectedOutlet.longitude}`
                                )} KM`
                                : ''}
                              &nbsp;
                              <FontAwesomeIcon icon={faMapMarkerAlt} color='var(--card-font-color)' />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </ModalBody>
            <ModalFooter className="no-border p-2 primary-color">
              <div className="container-fluid">
                <div className="row">
                  {this.props.isTakeAway && (
                    <Button
                      className={`col-lg-12 btn btn-primary btn-lg ${branding_btn}`}
                      disabled={!this.isDoneEnabled() || this.state.loading || this.state.isSaving}
                      onClick={this.onDone.bind(this)}
                    >
                      Done
                    </Button>
                  )}
                  {!this.props.isTakeAway && (
                    <Button
                      className={`col-lg-12 btn btn-primary btn-lg ${branding_btn}`}
                      disabled={this.state.isSaving || this.state.loading}
                      onClick={this.saveLocation.bind(this)}
                    >
                      Save Location
                    </Button>
                  )}
                </div>
              </div>
            </ModalFooter>
          </StyledMapModal>
        </React.Fragment>
      );
    }
  }
}

const StyledMapModal = styled(Modal)`
  .places {
    .modal-content-z-index {
      margin-top: 0 !important;

      .input-group {
        padding: 0 20px;
        height: 40px;
      }
    }

    .input-group {
      .input-group-text {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        background: #fff;
        border-color: rgba(209, 209, 209, 0.5);
      }

      .form-control {
        border: 1px solid rgba(209, 209, 209, 0.5) !important;

        &::placeholder {
          font-size: 14px;
           
          line-height: 16px;
          color: #d1d1d1;
          font-weight: 300;
        }
      }
    }
  }

  .map {
    width: calc(100% - 40px);
    margin: 0 auto;
    border: 1px solid rgba(209, 209, 209, 0.5);
    border-radius: 6px;
  }

  .modal-header {
    .modal-title {
      font-size: 16px;
       
      line-height: 22px;
    }

    .icon-close {
      width: 30px;
      height: 30px;
      border: 1px solid rgba(209, 209, 209, 0.5);
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }

  .order-types {
    row-gap: 15px;
    display: flex;
    flex-direction: column;

    form {
      .form-group {
        margin-top: 15px;

        &:nth-of-type(1) {
          margin-top: 0;
        }

        h2 {
          margin-top: 0;
          font-size: 14px;
          font-weight: normal;
           
          color: #6e6e6e;
          margin-bottom: 5px;
        }

        input {
          border: 1px solid rgba(209, 209, 209, 0.5);
          border-radius: 6px;
          padding: 12px 15px;

          &::placeholder {
            font-size: 14px;
             
            font-weight: 500;
            line-height: 16px;
            color: var(--card-font-color) !important;
            opacity: 0.4;
          }
        }
      }
    }
  }

  .modal-footer {
    padding: 0;
    // margin-top: 20px;

    .container-fluid {
      margin: 0;

      button {
        height: 50px;
      }
    }
  }
`;
export default MapModal;
